import React from 'react';
import { Menu, MenuItem, ListItemText, ListItemSecondaryAction, Typography, Divider, Box } from '@mui/material';

export const WL_PRESETS = [
  { key: '1', label: 'Soft Tissue', ww: 400,  wc: 40   },
  { key: '2', label: 'Lung',        ww: 1500, wc: -600 },
  { key: '3', label: 'Vessel/CTA',  ww: 600,  wc: 200  },
  { key: '4', label: 'Bone',        ww: 2000, wc: 400  },
  { key: '5', label: 'Brain',       ww: 80,   wc: 40   },
  { key: '6', label: 'Stroke',      ww: 40,   wc: 40   },
  { key: '7', label: 'Abdomen',     ww: 350,  wc: 50   },
  { key: '0', label: 'Auto W/L',    ww: 0,    wc: 0    },
];

export function WLContextMenu({ anchorPos, onClose, onSelect, onZoom, onContextMenu, contextTools = [], onToolSelect = null }) {
  const open = Boolean(anchorPos);
  const contextToolIds = new Set((contextTools || []).map(tool => typeof tool === 'string' ? tool : tool.id).filter(Boolean));
  const showWindowLevel = contextToolIds.size === 0 || contextToolIds.has('wl');
  const selectableContextTools = (contextTools || []).filter(tool => tool && tool.id && tool.id !== 'wl');
  const handleContextMenu = (event) => {
    onContextMenu?.(event);
  };
  const preventNativeSelectionStart = (event) => {
    if (event.button !== undefined && event.button !== 0) return;
    event.preventDefault();
  };

  return (
    <Menu
      open={open}
      onClose={onClose}
      onContextMenu={handleContextMenu}
      anchorReference="anchorPosition"
      anchorPosition={anchorPos}
      slotProps={{
        root: { onContextMenu: handleContextMenu, sx: { userSelect: 'none', WebkitUserSelect: 'none' } },
        backdrop: { onContextMenu: handleContextMenu, sx: { userSelect: 'none', WebkitUserSelect: 'none' } },
        list: { onContextMenu: handleContextMenu, onMouseDown: preventNativeSelectionStart, onPointerDown: preventNativeSelectionStart, sx: { userSelect: 'none', WebkitUserSelect: 'none' } },
        paper: {
          'data-wl-context-menu': 'true',
          onContextMenu: handleContextMenu,
          onMouseDown: preventNativeSelectionStart,
          onPointerDown: preventNativeSelectionStart,
          sx: { bgcolor: '#111', border: '1px solid #2a2a2a', borderRadius: 1, minWidth: 200, userSelect: 'none', WebkitUserSelect: 'none' },
        },
      }}
    >
      {showWindowLevel && <>
      <Box sx={{ px: 2, py: 0.5 }}>
        <Typography sx={{ color: 'primary.main', fontSize: 10, letterSpacing: 1.5, fontFamily: 'monospace' }}>
          WINDOW / LEVEL
        </Typography>
      </Box>
      <Divider sx={{ borderColor: '#1e1e1e' }} />
      {WL_PRESETS.map(preset => (
        <MenuItem
          key={preset.key}
          onClick={() => { onSelect(preset); onClose(); }}
          sx={{ py: 0.5, '&:hover': { bgcolor: '#1a2a2a' } }}
        >
          <ListItemText
            primary={preset.label}
            primaryTypographyProps={{ sx: { color: '#e0e0e0', fontSize: 13, fontFamily: 'monospace' } }}
          />
          <ListItemSecondaryAction>
            <Typography sx={{ color: '#555', fontSize: 11, fontFamily: 'monospace' }}>
              {preset.ww === 0 ? 'Auto' : 'W' + preset.ww + '/L' + preset.wc}
            </Typography>
          </ListItemSecondaryAction>
        </MenuItem>
      ))}
      </>}
      {selectableContextTools.length > 0 && <>
        <Divider sx={{ borderColor: '#1e1e1e', mt: 0.5 }} />
        <Box sx={{ px: 2, py: 0.5 }} data-tool-layout-profile="viewer.tool_layout">
          <Typography sx={{ color: 'primary.main', fontSize: 10, letterSpacing: 1.5, fontFamily: 'monospace' }}>TOOLS</Typography>
        </Box>
        {selectableContextTools.map(tool => (
          <MenuItem key={tool.id} onClick={() => { onToolSelect?.(tool.id); onClose(); }} sx={{ py: 0.5, '&:hover': { bgcolor: '#1a2a2a' } }}>
            <ListItemText primary={tool.shortLabel || tool.label || tool.id} primaryTypographyProps={{ sx: { color: '#e0e0e0', fontSize: 13, fontFamily: 'monospace' } }} />
          </MenuItem>
        ))}
      </>}
      {onZoom && showWindowLevel && <>
        <Divider sx={{ borderColor: '#1e1e1e', mt: 0.5 }} />
        <Box sx={{ px: 2, py: 0.5 }}>
          <Typography sx={{ color: 'primary.main', fontSize: 10, letterSpacing: 1.5, fontFamily: 'monospace' }}>
            ZOOM
          </Typography>
        </Box>
        {[
          { label: 'Fit (1:1)', value: 1.0 },
          { label: 'Zoom 1.5x', value: 1.5 },
          { label: 'Zoom 2x', value: 2.0 },
          { label: 'Zoom 3x', value: 3.0 },
          { label: 'Zoom 4x', value: 4.0 },
        ].map(z => (
          <MenuItem
            key={z.value}
            onClick={() => { onZoom(z.value); onClose(); }}
            sx={{ py: 0.5, '&:hover': { bgcolor: '#1a2a2a' } }}
          >
            <ListItemText
              primary={z.label}
              primaryTypographyProps={{ sx: { color: '#e0e0e0', fontSize: 13, fontFamily: 'monospace' } }}
            />
          </MenuItem>
        ))}
      </>}
    </Menu>
  );
}
